// LocalStorageService.js
export class LocalStorage {

    static setToken(tokenObj) {
        localStorage.setItem("token", tokenObj.access_token);
        localStorage.setItem("expires", tokenObj.expires);
    }

    static getToken() {
        return localStorage.getItem("token");
    }

    static clearToken() {
        localStorage.removeItem("token");
        localStorage.removeItem("expiration");
    }
}
